import "swiper/css/effect-fade";
import "swiper/css/free-mode";
import "swiper/css/grid";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css";
import "react-modal-video/css/modal-video.css";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "./assets/css/common.css";
import "rsuite/dist/rsuite.min.css";
import "./assets/other/switcher/switcher.css";
import "./assets/css/style.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import ScrollTop from "./constent/ScrollTop";
import AboutUs from "./pages/AboutUs";
import Faq from "./pages/Faq";

import ComingSoon from "./pages/ComingSoon";
import Account from "./pages/Account";
import MenuStyle4 from "./pages/MenuStyle4";

import ShopCheckout from "./pages/ShopCheckout";
import ContactUs from "./pages/ContactUs";
// import SignIn from "./elements/SignIn";
import OnlineOrder from "./pages/OnlineOrder";
import { useDispatch, useSelector } from "react-redux";
import { getRestaurantThunk } from "./store/restaurants";
import Home2 from "./pages/Home2";
import { useEffect } from "react";
import { checkIfLunchTime } from "./Utilts/helper";
import Order from "./pages/Order";


function App() {
  const dispatch = useDispatch()
  const restaurant = useSelector((state) => state.restaurant.restaurant);

  useEffect(() => {
    // Dispatch API call action only once when the component mounts
    dispatch(getRestaurantThunk(5));
  }, [dispatch]); // Empty dependency array ensures this effect runs only once

const filteredRestaurant = restaurant && !checkIfLunchTime()
    ? {
        ...restaurant,
        Categories: restaurant.Categories.filter(category => category.id !== 57)
      }
    : restaurant;
  return (
    <>
      <div className="page-wraper">
        <Router>
          {/* <SignIn /> */}
          <ScrollTop />
        
          <Routes>
              <Route exact path="/" element={<Home2 restaurant={filteredRestaurant} />} />
              <Route path="/online-order" element={<OnlineOrder restaurant={filteredRestaurant}/>} />
              <Route path="/menu" element={<MenuStyle4 restaurant={filteredRestaurant}/>} />

              <Route path="/about" element={<AboutUs />} />
              <Route path="/faq" element={<Faq />} />

              <Route path="/checkout" element={<ShopCheckout />} />

              <Route path="/contact" element={<ContactUs />} />
            <Route path="/order-confirmed" element={<ComingSoon />} />
            <Route path="/account" element={<Account />} />
            <Route path='/order/:id/:restaurant_id' element={<Order />} />
            </Routes>
            
          {/* <Switcher />// */}
        </Router>
      </div>
    </>
  );
}

export default App;
